export type FilterTypes = {
  modelFamily: string[];
  bodyType: string[];
  modelYear: string[];
  trimLine: string[];
  offerType: string[];
  // [key: string]: string | number | string[] | number[];
};

export type ExposedFiltersTypes = {
  [key: string]: boolean;
};

export const ALL_FILTERS_OPENED: ExposedFiltersTypes = {
  modelFamily: true,
  bodyType: true,
  modelYear: true,
  trimLine: true,
  offerType: true,
};

export const ALL_FILTERS_CLOSED: ExposedFiltersTypes = {
  modelFamily: false,
  bodyType: false,
  modelYear: false,
  trimLine: false,
  offerType: false,
};

export const INTIAL_FILTERS = {
  modelFamily: [],
  bodyType: [],
  modelYear: [],
  trimLine: [],
  offerType: [],
};

export const filtersTypesToRenderWithTypeName = [
  'exteriorColor',
  'interiorColor',
  'wheelSize',
  'price',
  'power',
  'mileage',
  'availableInMonths',
];

export const ACCEPTABLE_URL_PARAMS = [
  'carline-group',
  'carline',
  'body-style',
  'trimline',
  'year',
  'offer-type',
  'dag',
];

export const LIST_OF_BODY_TYPES = [
  'suv',
  'sedan',
  'sportback',
  'allroad quattro',
  'avant',
  'coupe',
  'roadster',
  'cabriolet',
  'spyder',
];
